<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title w-100 px-2 mb-0 pt-2">
        <div class="d-flex align-items-center">
          <label for="searchYear" class="m-0">{{ "SELECT_YEAR" | translate }}</label>
          <select [(ngModel)]="searchYear" (change)="reportsFilterList()" id="searchYear" class="form-control w-fit pr-4 ml-075 mb-0" [ngClass.xl]="' d-inline-block'">
            <option class="p-1" [value]="year" *ngFor="let year of selectRangeOfYears">{{ year }}</option>
          </select>
        </div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 50 : 100"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="filteredReport"
        >
          <ngx-datatable-column name="{{ 'MONTH' | translate }}" width="150" prop="month" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ formatLabel(row.month) | titlecase }} {{ row.year }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="enabled_label" width="150" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-info" *ngIf="!row.status">{{ row.enabled_label }}</span>
              <span class="badge badge-warning" *ngIf="row.status && row.status === 1">{{ row.enabled_label }}</span>
              <span class="badge badge-success" *ngIf="row.status && row.status === 2">{{ row.enabled_label }}</span>
              <span class="badge badge-danger" *ngIf="row.status && row.status === 3">{{ row.enabled_label }}</span>
              <span class="badge badge-secondary" *ngIf="row.status && row.status === 4">{{ "NOT_SENDED" | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button
                  class="btn btn-outline-secondary ml-1 mr-1 btn-sm"
                  [queryParams]="{ month: row.month, year: row.year }"
                  [routerLink]="'/dashboard/workday-report/user-report' + ((currentMonth === row.month && currentYear === row.year) || !row.id ? '' : '/' + row.id)"
                >
                  {{ "VIEW" | translate }}
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column name="{{ 'MONTH' | translate }}" width="150" prop="month" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-center mb-1" ngClass.md="pr-1">
                    <span>{{ formatLabel(row.month) | titlecase }} {{ row.year }}</span>
                    <span class="badge badge-info" *ngIf="!row.status">{{ row.enabled_label }}</span>
                    <span class="badge badge-warning" *ngIf="row.status && row.status === 1">{{ row.enabled_label }}</span>
                    <span class="badge badge-success" *ngIf="row.status && row.status === 2">{{ row.enabled_label }}</span>
                    <span class="badge badge-danger" *ngIf="row.status && row.status === 3">{{ row.enabled_label }}</span>
                    <span class="badge badge-secondary" *ngIf="row.status && row.status === 4">{{ "NOT_SENDED" | translate }}</span>
                  </div>
                  <div class="d-flex justify-content-end" ngClass.md="pr-1">
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      [routerLink]="currentMonth === row.month && currentYear === row.year ? '/dashboard/workday-report/user-report' : '/dashboard/workday-report/archive-view/' + row.id"
                      [queryParams]="{ month: row.month, year: row.year }"
                    >
                      {{ "VIEW" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
